"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELDSET = exports.COSTLY_TIME_BUDGET = exports.EFilterKeys = void 0;
var EFilterKeys;
(function (EFilterKeys) {
    EFilterKeys["ID"] = "feedItemId";
    EFilterKeys["TOPICS"] = "entity.topics";
    EFilterKeys["ATTACHMENTS_TYPE"] = "entity.attachments.mediaType";
    EFilterKeys["CURSOR"] = "page";
})(EFilterKeys || (exports.EFilterKeys = EFilterKeys = {}));
exports.COSTLY_TIME_BUDGET = 30000;
exports.FIELDSET = 'latestComments,reactions,requesterContext';
//# sourceMappingURL=constants.js.map